import styled from "styled-components";

import {
  BREAKPOINT,
  CARD_BACKGROUND,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  LARGE_BREAK_POINT,
} from "../../constants/Styles";

const MarketingCheckboxArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;

  > label {
    color: ${COLORS.secondaryLight};
    font-size: ${FONT_SIZE.size13};
    font-weight: ${FONT_WEIGHT.weight500};
    line-height: 1rem;
  }
`;

const Container = styled.div<{ useSmallSize: boolean; isSignUp: boolean }>`
  display: flex;
  width: 500px;
  padding: 3.5rem 4rem;
  flex-direction: column;
  align-items: center;
  border-radius: 1rem;

  @media (max-width: ${({ isSignUp }) =>
      isSignUp ? LARGE_BREAK_POINT : BREAKPOINT}) {
    width: 350px;
    padding: 3.5rem 2rem;
  }

  ${CARD_BACKGROUND};
  color: ${COLORS.secondary};

  ${({ useSmallSize }) => useSmallSize && `padding-bottom: 1rem;`}

  ${({ isSignUp }) =>
    isSignUp &&
    `  
    width: 842px;
    flex-wrap: wrap;
    flex-direction: row;`}
`;

const Header = styled.h2`
  font-family: ${FONTS.spaceGrotesk};
  font-weight: ${FONT_WEIGHT.weight500};
`;

const Form = styled.form<{ isSignUp: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  ${({ isSignUp }) =>
    isSignUp &&
    `  
      width: 385px;
    `}
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: ${FONT_SIZE.size13};
  color: ${COLORS.secondaryLight};
`;

const ButtonContainer = styled.div`
  > button {
    width: 100%;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`;

const FooterLink = styled.div`
  cursor: pointer;
  text-decoration: underline;
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size13};
  font-weight: ${FONT_WEIGHT.weight500};
  text-align: center;

  &:hover {
    color: ${COLORS.secondaryLight};
    filter: brightness(150%);
  }
`;

const VerticalLine = styled.div`
  border-left: 1px solid ${COLORS.secondaryLight};
  height: 1rem;
`;

const LeftColumn = styled.div`
  width: 250px;
  margin-right: 4rem;
`;

const DescriptionText = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight400};
  line-height: 1.5rem;
  margin-bottom: 1.5rem;
`;

const ThreeStepContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StepContainer = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
  align-items: center;
`;

const FormLabel = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size13};

  > span {
    filter: brightness(50%);
  }
`;

export {
  Container,
  Header,
  Form,
  InfoContainer,
  ButtonContainer,
  FooterLinks,
  VerticalLine,
  FooterLink,
  LeftColumn,
  DescriptionText,
  ThreeStepContainer,
  StepContainer,
  MarketingCheckboxArea,
  FormLabel,
};
